<template>
  <button class="pending-button" v-b-tooltip.hover title="Mark as Pending">
    <i class="fa fa-clock pending-icon"></i>
  </button>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style>
.pending-icon {
  font-size: 24px !important;
  cursor: pointer;
  transition: all 0.2s;
  color: rgb(116, 120, 141) !important;
}
.pending-button {
  background-color: inherit;
  border-radius: 10px;
  padding: 10px;
  border: 0px;
  transition: all 0.2s;
}
.pending-button:hover .pending-icon {
  transform: scale(1.3);
}
.pending-button:hover {
  background-color: rgba(116, 120, 141, 0.1);
}
</style>
